import { UPDATE_ADMIN_USER, DELETE_ADMIN_USER } from './actions';

const INITIAL_STATE = [];

const userReducer = (state = INITIAL_STATE, action) => {
     switch (action.type) {
          case DELETE_ADMIN_USER: {
               const newUsers = [...state];
               return newUsers.filter((user) => user.id !== action.payload);
          }

          case UPDATE_ADMIN_USER: {
               const newUsers = [...state];
               const _newUsers = newUsers.map((user) => {
                    if (user.id === action.payload.userId) {
                         return { ...user, ...action.payload.user };
                    }
                    return user;
               });
               return _newUsers;
          }

          default:
               return state;
     }
};

export default userReducer;
